module.exports = __webpack_public_path__ + "img/icon_legal-consultant.9b07307d.svg";